import React from 'react'

const Productpage = () => {
  return (
    <div>Productpage</div>
  )
}

export default Productpage